import { ModalProps } from "@mui/material";

import { Modal } from "@mui/material";

const ModalWrapperUI = (props: ModalProps) => {
  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxHeight: "100%",
        overflow: "scroll",
        width: "100%",
        height: "100%",
        backdropFilter: "blur(5px)",
      }}
      {...props}>
      {props.children}
    </Modal>
  );
};

export default ModalWrapperUI;
